<div class="bg-2 page-container">
  <app-header></app-header>

  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css">

  <main class="page-content">
    <section class="setpass-form-wrapper bg-2">
      <div class="setpass-container-setpass">
        <div class="setpass-box-setpass">
          <!-- Logo Section -->
          <div class="setpass-logo-section-setpass">
            <img src="assets/icon/gigsumologo_bigface.png" alt="Gigsumo" class="setpass-logo-setpass">
          </div>

          <!-- Welcome Text -->
          <div class="setpass-welcome-text-setpass">
            <h1>Change your password</h1>
            <p>Enter your current password and set a new strong password.</p>
          </div>

          <!-- Password Form -->
          <form [formGroup]="setpassword" class="setpass-form-setpass">
            <!-- Old Password Input -->
            <div class="setpass-input-group-setpass" id="show_hide_password_0" *ngIf="!resetPassword">
              <input 
                type="password"
                class="form-control"
                placeholder="Enter Old Password"
                formControlName="oldPassword"
                #oldpass
                id="passInput0"
                tabindex="1"
                (focus)="$event.target.select()"
                [class.error]="sign2.oldPassword.invalid && (sign2.oldPassword.dirty || sign2.oldPassword.touched)">
              <span class="setpass-input-icon-setpass">
                <ng-icon name="tablerLock"></ng-icon>
              </span>
              <button type="button" class="setpass-toggle-btn-setpass" tabindex="-1" (click)="showHidePass(0)">
                <i class="bi bi-eye-slash-fill"></i>
              </button>
              <div class="setpass-field-error-setpass" *ngIf="!sign2.oldPassword.errors?.required && worngPwd">
                Sorry! Your old password was incorrect!
              </div>
              <div class="setpass-field-error-setpass" *ngIf="sign2.oldPassword.invalid && (sign2.oldPassword.dirty || sign2.oldPassword.touched)">
                <div *ngIf="sign2.oldPassword.errors?.required">
                  Old password is required
                </div>
              </div>
            </div>

            <!-- New Password Input -->
            <div class="setpass-input-group-setpass" id="show_hide_password_1">
              <input 
                type="password"
                formControlName="newpassword"
                class="form-control"
                (keypress)="keyDown($event)"
                trim="blur"
                placeholder="Enter New Password"
                id="passInput1" 
                tabindex="2"
                (keyup)="onCheckValid()"
                (focus)="$event.target.select()"
                [class.error]="sign2.newpassword.invalid && (sign2.newpassword.dirty || sign2.newpassword.touched)">
              <span class="setpass-input-icon-setpass">
                <ng-icon name="tablerLock"></ng-icon>
              </span>
              <button type="button" class="setpass-toggle-btn-setpass" tabindex="-1" (click)="showHidePass(1)">
                <i class="bi bi-eye-slash-fill"></i>
              </button>
              <div class="setpass-field-error-setpass" *ngIf="sign2.newpassword.invalid && (sign2.newpassword.dirty || sign2.newpassword.touched)">
                <div *ngIf="sign2.newpassword.errors?.required">
                  Password is required
                </div>
              </div>
            </div>

            <!-- Confirm Password Input -->
            <div class="setpass-input-group-setpass" id="show_hide_password_2">
              <input 
                type="password"
                (keypress)="keyDown($event)"
                trim="blur"
                formControlName="confirmpassword"
                class="form-control"
                placeholder="Enter Confirm Password"
                id="passInput2"
                tabindex="3"
                (keyup)="checkPassword()"
                (focus)="$event.target.select()"
                [class.error]="sign2.confirmpassword.invalid && (sign2.confirmpassword.dirty || sign2.confirmpassword.touched)">
              <span class="setpass-input-icon-setpass">
                <ng-icon name="tablerLock"></ng-icon>
              </span>
              <button type="button" class="setpass-toggle-btn-setpass" tabindex="-1" (click)="showHidePass(2)">
                <i class="bi bi-eye-slash-fill"></i>
              </button>
              <div class="setpass-field-error-setpass" *ngIf="sign2.confirmpassword.invalid && (sign2.confirmpassword.dirty || sign2.confirmpassword.touched)">
                <div *ngIf="sign2.confirmpassword.errors?.required">
                  Confirm Password is required
                </div>
              </div>
            </div>

            <!-- Password Requirements -->
            <div class="setpass-requirements-setpass" id="message">
              <h4>Your password must have:</h4>
              <div class="setpass-requirements-list-setpass">
                <div id="length" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>8 or more alphanumeric characters</span>
                </div>
                <div id="capital" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>At least one uppercase letter</span>
                </div>
                <div id="letter" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>At least one lowercase letter</span>
                </div>
                <div id="number" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>At least one number</span>
                </div>
                <div id="specialCharacter" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>At least one special character</span>
                </div>
                <div id="passwordMatch" class="setpass-requirement-item-setpass invalid">
                  <i class="setpass-requirement-icon-setpass"></i>
                  <span>New and verify password match</span>
                </div>
              </div>
              <div class="setpass-strength-indicator">
                <small class="help-block" id="password-text"></small>
              </div>
            </div>

            <!-- Submit Button -->
            <button type="button" class="setpass-btn-primary-setpass" tabindex="4" (click)="updatePassword()">
              Change Password
            </button>
          </form>
        </div>
      </div>
    </section>
  </main>

  <app-footer></app-footer>
</div>
